// src/components/Header.jsx
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo/logo.png";
 
// Smooth scroll hook (kept simple and safe)
const useSmoothScroll = (offset = 100) => {
  useEffect(() => {
    const links = Array.from(document.querySelectorAll(".page-scroll"));

    const handleClick = (event) => {
      // If it's a NavLink (router) it will usually not have href starting with '#'
      const href = event.currentTarget.getAttribute("href");
      if (!href || !href.startsWith("#")) return;

      const targetId = href.slice(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      // prevent default and smooth scroll with offset
      event.preventDefault();

      // compute target position (account for offset)
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    };

    links.forEach((link) => link.addEventListener("click", handleClick));

    // cleanup
    return () => {
      links.forEach((link) => link.removeEventListener("click", handleClick));
    };
  }, [offset]);
};

const Header = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useSmoothScroll(80); // <-- call hook with 80px offset

  const toggleMobileNav = () => {
    setIsMobileNavOpen((prev) => !prev);
  };

  const closeMobileNav = () => {
    setIsMobileNavOpen(false);
  };

  return (
    <header id="header_main" className="header_1 header-fixed">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div id="site-header-inner">
              <div className="wrap-box flex">
                {/* Logo */}
                <div id="site-logo">
                  <div id="site-logo-inner">
                    <NavLink to="/" rel="home" className="main-logo">
                      <img id="logo_header" src={logo} alt="logo" />
                    </NavLink>
                  </div>
                </div>

                {/* Mobile button */}
                <div className="mobile-button" onClick={toggleMobileNav}>
                  <span></span>
                </div>

                {/* Desktop nav */}
                <nav id="main-nav" className="main-nav">
                  <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item current-menu-item">
                      <NavLink to="/" className="page-scroll">
                        Home
                      </NavLink>
                    </li>
                    <li className="menu-item">
                      <a href="#about" className="page-scroll">
                        About
                      </a>
                    </li>
                    <li className="menu-item">
                      <a href="#Services" className="page-scroll">
                        Services
                      </a>
                    </li>
                      <li className="menu-item">
                      <a href="#whychoose" className="page-scroll">
                        why choose 
                      </a>
                    </li>
                    <li className="menu-item">
                      <a href="#howItWorks" className="page-scroll">
                        How It Works
                      </a>
                    </li>
                      
                    <li className="menu-item">
                      <a href="#Technology" className="page-scroll">
                        Technology
                      </a>
                    </li>
                    <li className="menu-item">
                      <a href="#roadmap" className="page-scroll">
                        Roadmap
                      </a>
                    </li>
                     <li className="menu-item">
                      <a href="#faq" className="page-scroll">
                        Faq
                      </a>
                    </li>
                  </ul>
                </nav>

                {/* login btn */}
                <div className="flat-wallet">
                    <a href="https://login.bitwavecapital.io/" target="blank"  className="tf-button gradient-color">
                      <span>User Login</span> 
                    </a>  
                      <a href="https://login.bitwavecapital.io/register" target="blank"  className="tf-button ">
                      <span>Register</span> 
                    </a>  
                </div>
                {/* /flat-wallet */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile nav */}
      <div className={`mobile-nav-wrap ${isMobileNavOpen ? "active" : ""}`}>
        <div className="overlay-mobile-nav" onClick={closeMobileNav}></div>

        <div className="inner-mobile-nav">
          <NavLink to="/" rel="home" className="main-logo" onClick={closeMobileNav}>
            <img id="mobile-logo_header" src={logo} alt="logo" />
          </NavLink>

          <button type="button" className="mobile-nav-close" onClick={closeMobileNav}>
            <svg fill="black" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 122.878 122.88" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z" />
              </g>
            </svg>
          </button>

          <nav id="mobile-main-nav" className="mobile-main-nav">
            <ul id="menu-mobile-menu" className="menu">
              <li className="menu-item current-menu-item">
                <NavLink to="/" className="item-menu-mobile" onClick={closeMobileNav}>
                  Home
                </NavLink>
              </li>
              <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#about" onClick={closeMobileNav}>
                  About
                </a>
              </li>
               <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#Services" onClick={closeMobileNav}>
                  Services
                </a>
              </li>
               <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#whychoose" onClick={closeMobileNav}>
                 Why choose 
                </a>
              </li>

              <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#howItWorks" onClick={closeMobileNav}>
                  How It Works
                </a>
              </li>

              <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#Technology" onClick={closeMobileNav}>
                  Technology
                </a>
              </li>
              <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#roadmap" onClick={closeMobileNav}>
                  Roadmap
                </a>
              </li>
                <li className="menu-item">
                <a className="item-menu-mobile page-scroll" href="#faq" onClick={closeMobileNav}>
                 Faq
                </a>
              </li>
            </ul>
 
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
